import { useTranslation } from "react-i18next";
import { Task } from "@/types";
import React, { FC } from "react";
import Group from "@/components/atoms/Group";
import Stack from "@/components/atoms/Stack";
import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";
import Text from "@/components/atoms/Text";

import styles from "./styles.module.css";
import CTA from "@/components/atoms/CTA";

interface CreditRequestTaskProps {
  task: Task;
  onClose: () => void;
}

export const CreditRequestTask: FC<CreditRequestTaskProps> = ({ onClose }) => {
  const { t } = useTranslation();
  return (
    <Stack className="full flex col between h-100 py-10">
      <Group gap="20px" align="center" className={styles.taskHeader}>
        <SVGAsset name="economy" />
        <Text size="md" display="technical" tt="uppercase" strong={true}>
          {t("enumerables:taskTypes.CREDIT_REQUEST")}
        </Text>
      </Group>

      <Stack className={styles.tabPanelPadded}>
        <a href="/adminCompanies">
          <Text size="md">{t("tasks:creditRequestInstruction")}</Text>
        </a>
      </Stack>
      <Group className={styles.tabActionGroup} p={15} gap={16} align="center" justify="flex-end">
        <Group justify="end">
          <CTA intent="secondary" onClick={() => onClose()}>
            {t("actions:cancel")}
          </CTA>
        </Group>
      </Group>
    </Stack>
  );
};
